import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { ProfileSettingsContainer as Container } from '../../components';
import css from './Container.css';

// Custom hook for education data
const useEducationData = profileUser => {
  return useMemo(() => {
    const education = profileUser?.attributes?.profile?.publicData?.education;
    const hasValidEducation = education && education[0]?.when !== null;
    return { education, hasValidEducation };
  }, [profileUser]);
};

// Education item component
const EducationItem = ({ education }) => (
  <div className={css.container}>
    <div className={css.heading}>{education.where}</div>
    <div className={css.text}>
      {education.degree}, {education.industry}
    </div>
    <div className={css.text}>
      <FormattedMessage id="ProfilePage.educationGraduation" values={{ year: education.when }} />
    </div>
  </div>
);

const EducationContainer = ({ profileUser, button }) => {
  const { education, hasValidEducation } = useEducationData(profileUser);

  // Early return logic for when component should not render
  const shouldRender = useMemo(() => {
    if (button) return true;
    if (!education?.length) return false;
    if (education.length === 0 && Object.keys(education[0] || {}).length !== 0) return false;
    return hasValidEducation;
  }, [button, education, hasValidEducation]);

  if (!shouldRender) {
    return null;
  }

  return (
    <Container
      id="education"
      heading={<FormattedMessage id="ProfilePage.education" />}
      button={button}
    >
      {hasValidEducation &&
        education.map(educationItem => (
          <EducationItem key={educationItem.degree} education={educationItem} />
        ))}
    </Container>
  );
};

export default EducationContainer;
